const defaultNames = {
  'processmaker-modeler-end-event': 'End Event',
  'processmaker-modeler-error-end-event': 'Error End Event',
  'processmaker-modeler-message-end-event': 'Message End Event',
  'processmaker-modeler-signal-end-event': 'Signal End Event',
  'processmaker-modeler-terminate-end-event': 'Terminate End Event',
};

export default defaultNames;
